import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { CommonService } from '../Common-function/common.service';

@Injectable({
  providedIn: 'root'
})
export class SaleTimerService {

  saleStatus$ = new BehaviorSubject<'upcoming' | 'live' | 'ended'>('upcoming');
  private timerSub?: Subscription;

  saleStart: Date | null = null;
  saleEnd: Date | null = null;
  /** No status until the platform sale data has arrived (avoids a false "ended" from placeholder dates) */
  private hasSaleData = false;


  constructor(private commonService: CommonService) {
    this.startTimer();
  }


   private startTimer() {
     this.commonService.platformSaleData.subscribe((saleData) => {
      if (Array.isArray(saleData)) {
        const activeSaleData = saleData.find((item: any) => item.is_active === true);
        this.saleStart = activeSaleData?.start_at ? new Date(activeSaleData.start_at) : null;
        this.saleEnd = activeSaleData?.end_at ? new Date(activeSaleData.end_at) : null;
        this.hasSaleData = true;
        this.checkSaleStatus();
      }
    });
    // keeps running: the countdown can reach the start / end at any time, and a new sale can come in
    this.timerSub = interval(1000).subscribe(() => this.checkSaleStatus());
  }


  private checkSaleStatus() {
    if (!this.hasSaleData) {
      return;
    }
    const now = new Date();
    let status: 'upcoming' | 'live' | 'ended';
    if (!this.saleStart || !this.saleEnd) {
      status = 'ended';
    } else if (now < this.saleStart) {
      status = 'upcoming';
    } else if (now <= this.saleEnd) {
      status = 'live';
    } else {
      status = 'ended';
    }
    // only on a change (start / end), not every second
    if (status !== this.saleStatus$.value) {
      this.saleStatus$.next(status);
    }
  }
}
